import i18next from 'i18next';

import { canEditSalesPlanning } from '@selectors/actions/salesPlanningActions';

export const getActions = ({
  handleXLSExport,
  setDisplayPDFconfig,
  openProductForecastTemplateDownloadModal,
  openProductForecastBatchImportModal,
  authorizedActions,
}) => {
  const actions = [
    {
      label: i18next.t('GENERAL.ACTION_XLS_EXPORT'),
      icon: `/images/inpulse/file-download-black-small.svg`,
      handleClick: handleXLSExport,
    },
    {
      label: i18next.t('FORECAST.SALES_PLANNING.ACTION_GENERATE_PRODUCTION_PLANNING_PDF'),
      icon: `/images/inpulse/file-download-black-small.svg`,
      handleClick: () => {
        setDisplayPDFconfig(true);
      },
    },
  ];

  if (canEditSalesPlanning(authorizedActions)) {
    actions.push(
      {
        id: 'download_batch_creation_file_template',
        label: i18next.t('FORECAST.SALES_PLANNING.PRODUCT_FORECAST_TEMPLATE_FILE_DOWNLOAD'),
        icon: () => '/images/inpulse/file-download-black-small.svg',
        handleClick: () => openProductForecastTemplateDownloadModal(),
      },
      {
        id: 'import_batch_creation_file',
        label: i18next.t('FORECAST.SALES_PLANNING.PRODUCT_FORECAST_TEMPLATE_FILE_IMPORT'),
        icon: () => '/images/inpulse/file-upload-black-small.svg',
        handleClick: () => openProductForecastBatchImportModal(),
      },
    );
  }

  return actions;
};
